/* @ngInject */
const parkOptions = (
  utils,
  types,
  excelStyles,
  wagonUtils,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'parkCertificate'
    options.enableColor = true
    options.enableOwnerSheet = true
    options.disableOwnerColor = true
    options.firstRow = 7
    options.getBodyCells = self.getBodyCells
    options.getHeaderCells = self.getHeaderCells
    options.style = excelStyles.bodyCell()

    return options
  }

  self.getHeaderCells = (train) => {
    return [{
      name: 'E3',
      value: train.date,
      type: types.date,
    }, {
      name: 'I3',
      value: train.tractionnaire,
    }, {
      name: 'O3',
      value: train.number,
    },]
  }

  self.getBodyCells = ({ currentRow, }, wagon) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
      style: excelStyles.bodyCell(),
    }, {
      name: 'B' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'C' + currentRow,
      ref: 'type',
      value: wagon.type,
    }, {
      name: 'D' + currentRow,
      ref: 'set',
      value: wagon.set,
    }, {
      name: 'E' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'F' + currentRow,
      ref: 'position',
      value: wagon.position,
      type: types.integer,
    }, {
      name: 'G' + currentRow,
      ref: 'completeRevisionExcel',
      value: wagon.completeRevisionExcel,
    }, {
      name: 'H' + currentRow,
      ref: 'length',
      value: wagon.length,
      type: types.decimal,
    }, {
      name: 'I' + currentRow,
      ref: 'tare',
      value: wagon.tare,
      type: types.integer,
    }, {
      name: 'J' + currentRow,
      ref: 'brakedMass',
      value: wagon.brakedMass,
      type: types.integer,
    }, {
      name: 'K' + currentRow,
      ref: 'isolated',
      value: wagon.isolated,
      type: types.boolean,
    }, {
      name: 'L' + currentRow,
      ref: 'damaged',
      value: wagon.damaged,
      type: types.boolean,
    }, {
      name: 'M' + currentRow,
    }, {
      name: 'N' + currentRow,
    }, {
      name: 'O' + currentRow,
      value: wagon.idNew ? `Nouveau numéro : \n${wagonUtils.idToString(wagon.idNew)}` : ''
    },]
  }

  return self
}
export default parkOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/parkOptions.resource.js